import { render, staticRenderFns } from "./PostAssessmentCard.vue?vue&type=template&id=3c7bcb8c&scoped=true"
import script from "./PostAssessmentCard.vue?vue&type=script&lang=js"
export * from "./PostAssessmentCard.vue?vue&type=script&lang=js"
import style0 from "./PostAssessmentCard.vue?vue&type=style&index=0&id=3c7bcb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7bcb8c",
  null
  
)

export default component.exports